import * as React from "react";
import Svg, { Path } from "react-native-svg";

function LtiNotConfiguredIcon({ size = 32, color = "#0B69A3", ...props }) {
  return (
    <Svg width={size} height={size} viewBox="0 0 256 256" fill="none" {...props}>
      <Path
        d="M212 132l-58.63 58.63a32 32 0 0 1-45.25 0L65.37 147.88a32 32 0 0 1 0-45.25L124 44Z"
        fill={color}
        opacity={0.2}
      />
      <Path
        d="M237.66 66.34a8 8 0 0 0-11.32 0L192 100.69 155.31 64l34.35-34.34a8 8 0 1 0-11.32-11.32L144 52.69 117.66 26.34a8 8 0 0 0-11.32 11.32L112.69 44l-53 53a40 40 0 0 0 0 56.57l15.71 15.71-49.06 49.06a8 8 0 0 0 11.32 11.32l49.09-49.09 15.71 15.71a40 40 0 0 0 56.57 0l53-53 6.34 6.35a8 8 0 0 0 11.32-11.32L203.31 112l34.35-34.34a8 8 0 0 0 0-11.32ZM147.72 185a24 24 0 0 1-33.95 0L71 142.23a24 24 0 0 1 0-33.95l53-53L200.69 132Z"
        fill={color}
      />
    </Svg>
  );
}

export default LtiNotConfiguredIcon;
